<div class="cbc-master-file-required-dialog">
  <div class="cbc-master-file-required-default">
    <span>Default Value: &nbsp;&nbsp;&nbsp; {{cbcMasterFileRequiredDefaultValue}}</span>
  </div>

  <div class="cbc-master-file-required-overwrite">
    <mat-checkbox [(ngModel)]="MasterFileRequiredOverwrite">Overwrite</mat-checkbox>
    <mat-radio-group class="overwrite-options" [(ngModel)]="overwrittenCellValue">
      <mat-radio-button class="overwrite-option-value" [disabled]="!MasterFileRequiredOverwrite"  value="Yes">Yes</mat-radio-button>
      <mat-radio-button class="overwrite-option-value" [disabled]="!MasterFileRequiredOverwrite"  value="No">No</mat-radio-button>
    </mat-radio-group>
  </div>
</div>
